<template>
  <div class="bilancio">
    <navbar></navbar>
    <b-container style="height: 80vh;">
      <b-row style="height: 80%;">
          <b-col id="list-user">
            <h2>LISTA BILANCI CARICATA</h2>
            <scrolly id="list">
              <scrolly-viewport>
                <b-list-group v-for="(value, index) in bilancio" :key="index">
                  <b-list-group-item v-if="index%2 == 0" v-on:click="modalAnagraficaOpen(value)">{{value.cod_contab}}</b-list-group-item>
                  <b-list-group-item variant="secondary" v-else v-on:click="modalAnagraficaOpen(value)">{{value.cod_contab}}</b-list-group-item>
                </b-list-group>
              </scrolly-viewport>
              <scrolly-bar axis="y"></scrolly-bar>
              <scrolly-bar axis="x"></scrolly-bar>
            </scrolly>
          </b-col>
          <b-col id="add-user">
            <h2>CARICA BILANCIO</h2>
            <br>
            <b-form v-on:submit.prevent="addBilancio" enctype="multipart/form-data">
              <b-input-group prepend="Trimestre">
                <b-form-select v-model="trimestre" :options="trimestreList" :state="state.trimestre" :disabled="stato != -1"></b-form-select>
                <b-input-group-append>
                  <b-input-group prepend="Anno">
                    <b-form-input v-model="anno" type="number" placeholder="Anno del bilancio" :state="state.anno" :disabled="stato != -1"></b-form-input>
                  </b-input-group>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-input-group prepend="Bilancio">
                <b-form-file v-model="file" placeholder="Seleziona i file di bilancio..." :state="state.file" :disabled="stato != -1" multiple></b-form-file>
              </b-input-group>
              <br>
              <b-button type="submit" variant="success" :disabled="stato != -1">
                <div class="spinner">
                  <p v-if="stato != -1">Caricamento in corso</p>
                  <p v-else>Carica bilancio</p>
                  <div class="bounce1" v-if="stato != -1"></div>
                  <div class="bounce2" v-if="stato != -1"></div>
                  <div class="bounce3" v-if="stato != -1"></div>
                  <b-badge variant="light" v-if="stato != -1" style="margin-left: 8px">{{stato}}/{{tot_tuple}}</b-badge>
                </div>
              </b-button>
              <br>
              <br>
              <p>Esempio nome file valido: "03 4000 B (00001 - 10231).txt"</p>
              <p>Il contenuto fra parentesi &egrave; facoltativo.</p>
            </b-form>
            <scrolly v-if="error_pipe.length > 0" :style="{height: '200px'}">
              <scrolly-viewport>
                <b-list-group v-for="(value, index) in error_pipe" :key="index">
                  <b-list-group-item :variant="value.error_type">{{value.msg}}</b-list-group-item>
                </b-list-group>
              </scrolly-viewport>
              <scrolly-bar axis="y"></scrolly-bar>
              <scrolly-bar axis="x"></scrolly-bar>
            </scrolly>
          </b-col>
      </b-row>
  </b-container>
  <b-modal v-model="modal.bilancio" title="Dettagli bilancio">
    <b-form v-on:submit.prevent="addBilancio">
      <b-input-group prepend="Cod. contabilità">
        <b-form-input v-model="modaldata.cod_contab" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Trimestre">
        <b-form-select v-model="modaldata.trimestre" :options="trimestreList" disabled></b-form-select>
        <b-input-group-append>
          <b-input-group prepend="Anno">
            <b-form-input v-model="modaldata.anno" type="number" placeholder="Anno del bilancio" disabled style="width: 120px"></b-form-input>
          </b-input-group>
        </b-input-group-append>
      </b-input-group>
      <br>
      <b-input-group prepend="Costo">
        <b-form-input v-model="modaldata.costo" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Margine">
        <b-form-input v-model="modaldata.margine" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Utenze">
        <b-form-input v-model="modaldata.utenze" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Altri servizi">
        <b-form-input v-model="modaldata.altriserv" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Totale costi">
        <b-form-input v-model="modaldata.totcosti" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Risultato lordo">
        <b-form-input v-model="modaldata.rislordo" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Oneri finanziari">
        <b-form-input v-model="modaldata.onerifinanz" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Totale oneri finanziari">
        <b-form-input v-model="modaldata.totonerifin" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Altri provcalc">
        <b-form-input v-model="modaldata.altriprovcalc" disabled></b-form-input>
      </b-input-group>
      <br>
    </b-form>

    <div slot="modal-footer" class="w-100" v-if="!modal.bilanciodelete">
      <b-container>
        <b-row>
          <b-col><b-button variant="danger" size="sm" v-on:click="modal.bilanciodelete = true">Elimina</b-button></b-col>
          <b-col></b-col>
          <b-col><b-button variant="secondary" style="float: right;" v-on:click="modal.bilancio = false">Chiudi</b-button></b-col>
        </b-row>
      </b-container>
    </div>
    <div slot="modal-footer" class="w-100" v-else>
      <p style="float: left;">Si sta eliminando questo elemento, proseguire?</p>
      <b-button variant="secondary" style="float: right; margin-left: 10px;" v-on:click="modal.bilanciodelete = false">No</b-button>
      <b-button variant="danger" style="float: right;" v-on:click="deleteBilancio(modaldata.id)">Si</b-button>
    </div>
  </b-modal>
  </div>
  
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly'

export default {
  name: 'bilancio',
  components: {
    navbar,
    Scrolly,
    ScrollyViewport,
    ScrollyBar
  },
  data() {
    return {
      bilancio: [],
      file: [],
      trimestre: null,
      anno: (new Date()).getFullYear(),
      modal: {
        bilancio: false,
        bilanciodelete: false
      },
      trimestreList: [
        { value: null, text: 'Seleziona il trimestre' },
        { value: '1', text: 'Primo trimestre' },
        { value: '2', text: 'Secondo trimestre' },
        { value: '3', text: 'Terzo trimestre' },
        { value: '4', text: 'Quarto trimestre' }
      ],
      modaldata: {},
      stato: -1,
      tot_tuple: 0,
      state: {
        file: null,
        trimestre: null,
        anno: null
      },
      error_pipe: []
    }
  },
  created: function(){
        this.updateBilancioList()
        this.getUploadStato()
  },
  methods: {
    addBilancio() {
      console.log(this.file)
      if(this.file.length != 0 && this.trimestre != null && this.anno > 0){
        this.error_pipe = []
        //disabilito errori input
        this.state.file = true
        this.state.trimestre = true
        this.state.anno = true
        //creo richiesta
        this.stato = 0
        //this.$Progress.start()
        let formData = new FormData()
        formData.append('trimestre', this.trimestre)
        formData.append('anno', this.anno)

        for(var i=0; i<this.file.length; i++)
          formData.append('f1[]', this.file[i])
        
        Vue.http.post(this.$hostlink+'bilancio/upload', formData, {credentials : true, headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
          if(response.body.success){
            this.tot_tuple = response.body.tot_tuple
            this.getUploadStato()
            //this.$Progress.finish()
            Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'File caricato con successo!',
              type: 'success'
            })
            Vue.notify({
              group: 'global',
              title: 'Elaborazione in corso...',
              text: 'Il server sta elaborando '+response.body.tot_tuple+' elementi!',
              type: 'info'
            })
          }
        }, response => {
          this.state.file = false
          this.state.trimestre = false
          this.state.anno = false
          Vue.notify({
            group: 'global',
            title: 'Errore di comunicazione',
            text: response.body.msg,
            type: 'error'
          })
          //this.$Progress.fail()

          if(response.body.error)
            this.stato = -1
        })
      }else{
        //segnalo campi non validi
        if(this.file.length == 0)
          this.state.file = false
        if(this.trimestre == null)
          this.state.trimestre = false
        if(this.anno <= 0)
          this.state.anno = false
        Vue.notify({
          group: 'global',
          title: 'Nessun file selezionato',
          text: 'Assicurati di aver compilato tutti i campi correttamente!',
          type: 'error'
        })
      }
    },
    updateBilancioList(){
      Vue.http.post(this.$hostlink+'bilancio/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.bilancio = response.body.data
        }
      }, response => {
          // error callback
      })
    },
    deleteBilancio(id){
      Vue.http.post(this.$hostlink+'bilancio/delete', {id: id}, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione eseguita',
            text: 'Bilancio eliminato con successo!',
            type: 'success'
          })
        }else
          Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: 'Errore durante l\'eliminazione del bilancio. Verificare se non è stato precedentemente eliminato!',
            type: 'error'
          })
        this.modal.bilancio = false
        this.updateBilancioList()
      }, response => {
        Vue.notify({
          group: 'global',
          title: 'Errore!',
          text: 'Errore durante la comunicazione con il server!',
          type: 'error'
        })
      })
    },
    modalAnagraficaOpen(anagrafica){
      this.modaldata = anagrafica
      this.modal.bilanciodelete = false
      this.modal.bilancio = true
    },
    getUploadStato(){
       Vue.http.post(this.$hostlink+'bilancio/upload/get', {}, {credentials : true}).then(response => {
         if(response.body.success){
           if(this.tot_tuple == 0){
             this.tot_tuple = response.body.tot_tuple
           }
           this.stato = response.body.tot_stored
           if(!response.body.upload_end){
             setTimeout(this.getUploadStato, 500);
           }else{
            this.stato = -1
            this.tot_tuple = 0
            if(response.body.tot_stored != -1)
              Vue.notify({
                group: 'global',
                title: 'Operazione eseguita',
                text: 'Bilancio caricato con successo!',
                type: 'success'
              })
            this.updateBilancioList()
            if(response.body.error){
              Vue.notify({
                group: 'global',
                title: 'Ci sono alcuni errori',
                text: 'Durante l\'elaborazione del file ci sono stati degli errori!',
                type: 'warn'
              })
              Vue.http.post(this.$hostlink+'bilancio/upload/error', {}, {credentials : true}).then(resp => {
                console.log(resp.body.error_info)
                this.error_pipe = resp.body.error_info
              })
            }
          }
         }else{
           Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: 'Errore durante la comunicazione con il server!',
            type: 'error'
          })
         }
       })
    }
  }
}
</script>

<style>
#list-user{
  margin-top: 10%;
}

#list{
  height: 100%;
}

#add-user{
  margin-top: 10%;
  height: 100%;
}

/*CSS loader animated*/
.spinner {
  /*margin: 100px auto 0;*/
  /*width: 70px;*/
  text-align: center;
}

.spinner > div {
  width: 8px;
  height: 8px;
  background-color: white;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner > p {
  margin: 0;
  float: left;
  margin-right: 8px;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
